import { type CustomerPoint } from '../../context/CustomerContext';
import axios from 'axios';
// import { mode, tenantId } from '../../globals_VITE';
import { basename } from "../../globals_VITE";

export interface Customer {
  customer_id: number; // Primary key
  legal_name: string;
  address: string;
  country: string;
  city: string;
  phone: string;
}

export const getPointsDrf = async (): Promise<CustomerPoint[]> => {
    console.log('[getPointsDrf] called');
    const res = await axios.get<CustomerPoint[]>('pcnt/point/');
    return res.data;
}


export const getCustomer = async (customer_id: number): Promise<Customer[]> => {
    console.log('[getCustomer] customer_id:', customer_id);
    const res = await axios.get<Customer>(`pcnt/customer/${customer_id}/`);
    return [res.data];
};

export interface ValueLabel {
    value: number;
    label: string;
}

export const getCustomersVL = async (): Promise<ValueLabel[]> => {
    console.log('[getCustomers]');
    const res = await axios.get<Customer[]>(`pcnt/customer/`);
    const data: ValueLabel[] = res.data
        .sort((a,b) => a.customer_id - b.customer_id)
        .map((cu) => ({value: cu.customer_id, label: cu.legal_name}));
    return data;
};

export const registerCustomer = async (data: Customer, _userId: number, _email: string ): Promise<Customer | null> => {
    console.log('[registerCustomer] ', data);
    console.log('basename', basename);

    // 2026-05-05 registration_next/
    const res = await axios.post(basename+'/identity/registration_next/', {
        "user_info": {
            // "first_name": "Fred",
            // "last_name": "Fredding",
            // "phone": "+38050543210"
        },
        "customer_info": {
            "legal_name": data.legal_name,
            "address": data.address,
            "country": data.country,
            "city": data.city,
            "phone": data.phone,
            "lang": "uk", // todo: get from user settings or browser settings
            "currency": "UAH", //todo: get from user settings or browser settings
            "tz": "Europe/Kyiv", //todo: get from user settings or browser settings
        }
    });
    return res.data;
}

export const putCustomer = async (customer: Customer): Promise<Customer | null> => {
    const res = await axios.put<Customer>(`/pcnt/customer/${customer.customer_id}/`, customer);
    return res.data;
}
